import { POS_ROUTE } from "../../constants/constants";

export const POS_ORDERS_ROUTE = POS_ROUTE + "/orders"
export const POS_APP_MENU_ROUTE= POS_ROUTE + "/menu"

export const POS_APP_MENU_ROUTE_NEW_ORDER = "/order-menu"